import { canUseLogScale } from "../../utils/charts";
import { Box, Popover, FormControlLabel, Switch } from "@mui/material";
import DownloadButtons from "./Downloads";

export default function MobilePopover({
    id,
    open,
    anchorEl,
    handleClose,
    info,
    item_code,
    data,
    showDataLabels,
    useLogScale,
    toggleLogScale,
    showSubregions,
    toggleDataLabels,
    toggleSubregions,
    originalData,
    refDownload,
    title,
    country,
    params,
    currentTab
}) {
    const canShowSubregionToggle = () => {
        const hasMultipleCombos = (
            Array.isArray(info?.item_code) && info.item_code.length > 1
        ) || (
            Array.isArray(info?.element_code) && info.element_code.length > 1
        ) || (
            Array.isArray(info?.indicator_code) && info.indicator_code.length > 1
        );

        const hasSubregionalSeries = () => {
            if (info?.chart_type === "line") {
                return (data?.datasets?.length ?? 0) > 1;
            }
            if (info?.chart_type === "multipleAxis") {
                return (data?.compareDatasets?.length ?? 0) > 0;
            }
            return false;
        };

        if (info?.exclude_subregional_comparison) return false;

        if (info?.chart_type === "line") {
            if (hasMultipleCombos) return false;
            return hasSubregionalSeries();
        }

        if (info?.chart_type === "multipleAxis") {
            return hasSubregionalSeries();
        }

        return false;
    };

    return (
        <Popover
            id={id}
            open={open}
            anchorEl={anchorEl}
            onClose={handleClose}
            anchorOrigin={{
                vertical: "bottom",
                horizontal: "right",
            }}
            transformOrigin={{
                vertical: "top",
                horizontal: "right",
            }}
        >
            <Box
                sx={{
                    paddingTop: 1,
                    paddingRight: 1,
                    paddingBottom: 1,
                    paddingLeft: 2,
                }}
                display="flex"
                alignItems="flex-start"
                flexDirection="column"
                flexWrap="wrap"
            >
                {info?.chart_type === "line" && !info?.dual_axis && canUseLogScale(data) && (
                    <FormControlLabel
                        control={
                            <Switch
                                checked={Boolean(useLogScale)}
                                size="small"
                                onChange={toggleLogScale}
                            />
                        }
                        label="Log scale"
                        sx={{ "& .MuiFormControlLabel-label": { fontSize: "12px" } }}
                    />
                )}
                {canShowSubregionToggle() && (

                    <FormControlLabel
                        control={
                            <Switch
                                defaultChecked={info.chart_type === "multipleAxis" ? false : showSubregions ? false : true}
                                size="small"
                                onClick={toggleSubregions}
                            />
                        }
                        label="Subregion values"
                    />
                )}
                <FormControlLabel
                    control={
                        <Switch
                            size="small"
                            onClick={toggleDataLabels}
                            defaultChecked={showDataLabels ? true : false}
                        />
                    }
                    label="Data labels"
                />
                <Box
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    sx={{ fontSize: "smaller", ml: -1.5 }}
                >
                    <DownloadButtons
                        originalData={originalData}
                        ref={refDownload}
                        title={info?.label}
                        country={country}
                        params={params}
                        data={data}
                        currentTab={currentTab}
                    />
                </Box>
            </Box>
        </Popover>
    );
}
